var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowNotail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61631 2.04494C6.38197 2.27935 6.25033 2.59723 6.25033 2.92869C6.25033 3.26014 6.38197 3.57803 6.61631 3.81244L12.8038 9.99994L6.61631 16.1874C6.38861 16.4232 6.26262 16.7389 6.26547 17.0667C6.26832 17.3944 6.39978 17.708 6.63154 17.9397C6.8633 18.1715 7.17681 18.3029 7.50456 18.3058C7.83231 18.3086 8.14806 18.1826 8.38381 17.9549L15.4551 10.8837C15.6894 10.6493 15.821 10.3314 15.821 9.99994C15.821 9.66848 15.6894 9.3506 15.4551 9.11619L8.38381 2.04494C8.1494 1.8106 7.83152 1.67896 7.50006 1.67896C7.16861 1.67896 6.85072 1.8106 6.61631 2.04494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNotail);
export default __webpack_public_path__ + "static/media/arrow-notail.9ccabcd62d7e424ffe1afb9a49b31a23.svg";
export { ForwardRef as ReactComponent };